import { render, staticRenderFns } from "./customerHeader.vue?vue&type=template&id=7851e590&scoped=true&"
import script from "./customerHeader.vue?vue&type=script&lang=js&"
export * from "./customerHeader.vue?vue&type=script&lang=js&"
import style0 from "./customerHeader.vue?vue&type=style&index=0&id=7851e590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851e590",
  null
  
)

export default component.exports